import { useEffect } from "react"
import GroupMasterForm from "./GroupMasterForm"

const GroupMaster = ({ open }) => {
    useEffect(() => {
        document.title = 'Group Master'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <GroupMasterForm />
        </main>
    )
}
export default GroupMaster